import { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import { EngagementTagDetails } from './EngagementTagDetails'

interface EngagementTagProps {
  label: string
  details: string[]
  icon?: React.ReactNode
  'data-testid'?: string
}

export const EngagementTag: FC<EngagementTagProps> = ({ label, details, icon, 'data-testid': dataTestId }) => {
  const shouldShowCopyIcon = () => {
    return label === 'Engagement ID' && details.length === 1
  }

  return (
    <Stack direction="column" sx={{ gap: 'var(--spacing-3xs)' }} data-testid={dataTestId}>
      <Typography sx={{ color: 'var(--text-secondary)' }}>{label}</Typography>
      <EngagementTagDetails
        details={details}
        shouldShowCopyIcon={shouldShowCopyIcon()}
        shouldTruncateDetail={shouldShowCopyIcon()}
        icon={icon}
        copyLabel={label}
      />
    </Stack>
  )
}
